import React from "react";
import { Grid, InputAdornment } from "@mui/material";
import { Icon } from "../../utils/MuiIcons/Icon";
import FixedDecimalTextField from "../InputTableDefault/components/FixedDecimalTextField";

function NUMBER({ data, ind, error, textValue, handleTextValue }) {
  const component = data?.component || {};
  const fieldName = component?.sName;

  const adornment = component?.sAdornPosition ? (
    <InputAdornment position={component.sAdornPosition}>
      {component.sAdornType === "Icon" ? (
        <Icon iconName={component?.sIcon?.slice(0, -4)} />
      ) : component.sAdornType === "Text" ? (
        component.sIcon
      ) : null}
    </InputAdornment>
  ) : null;

  const inputAdornmentProps = component?.sAdornPosition === "Start"
    ? { startAdornment: adornment }
    : component?.sAdornPosition
      ? { endAdornment: adornment }
      : undefined;

  return (
    <Grid item {...data?.grid_props}>
      <FixedDecimalTextField
        {...component?.sProps}
        component={component}
        id={fieldName}
        name={fieldName}
        label={component?.sLabel}
        placeholder={component?.sPlaceHolder}
        value={textValue?.[fieldName] ?? component?.sDefaultValue ?? "0"}
        onValueChange={value => {
          handleTextValue(
            {
              target: {
                name: fieldName,
                value,
                decimalPlaces: component?.iDecimalPlaces,
              },
            },
            ind,
            data?.validation,
          );
        }}
        helperText={component?.sHelper}
        error={error && error[fieldName]}
        InputProps={inputAdornmentProps}
        stopPropagation={false}
      />
    </Grid>
  );
}

export default NUMBER;
